import { LanguageCode } from '@elsevier-health/osmosis-shared/languages';
import serverContext from 'server-only-context';
import { IntlData } from '../types/poeditor';

export const [getLocale, setLocale] = serverContext<LanguageCode>(
  LanguageCode.EN,
);

export const [getIntlMessages, setIntlMessages] = serverContext<
  IntlData['intlMessages']
>({});

/**
 * Set locale and intl messages in the server context
 */
export const setMessagesWithLanguage = (
  locale: LanguageCode,
  intlMessages: IntlData['intlMessages'],
) => {
  setLocale(locale);
  setIntlMessages(intlMessages);
};
